module.exports = "/_next/static/images/up-duotone-0072c3e2b96a997a4748aa8e5774f7b7.svg";